import { createStyles, makeStyles } from '@material-ui/core';
interface getAssessmentProfessionalStandardInterface {
  medicine_name: string
  typeofdifficultlevel_name: string
  organization_name: string
  student_speciality_name: string
  tasc_name: string
  testingstage_name: string
  trainer_name: string
  universitylevel_name: string
  count: number
}
interface ChampionMobileElement {
  ratingElement: getAssessmentProfessionalStandardInterface
}
export default function AnalyticMobileElement ({ratingElement}: ChampionMobileElement) {
  const useStyles = makeStyles((theme) =>
    createStyles({
      ratingMobileElementContainer: {
        border: '1px solid gray',
        borderRadius: 12,
        padding: 10,
        margin: '15px auto',
        maxWidth: 1045,
        width: '100%'
      },
      titleChapter: {
        fontWeight: 700,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        marginTop: 2
      },
      textWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 10
      },
      descriptionChapter: {
        fontWeight: 400,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        marginTop: 2
      }
    })
  );
  const style = useStyles()
  return (
    <div className={style.ratingMobileElementContainer}>
      <div className={style.textWrapper}>
        <p className={style.titleChapter}>Раздел медицины: </p>
        <span className={style.descriptionChapter}>{ratingElement.medicine_name}</span>
      </div>
      <div className={style.textWrapper}>
        <p className={style.titleChapter}>Уровень сложности: </p>
        <span className={style.descriptionChapter}>{ratingElement.typeofdifficultlevel_name}</span>
      </div>
      <div style={{margin: '4px auto'}}>
        <p className={style.titleChapter}>Организация: </p>
        <span className={style.descriptionChapter}>{ratingElement.organization_name}</span>
      </div>
      <div className={style.textWrapper}>
        <p className={style.titleChapter}>Специальность: </p>
        <span className={style.descriptionChapter}>{ratingElement.student_speciality_name}</span>
      </div>
      <div className={style.textWrapper}>
        <p className={style.titleChapter}>Задача: </p>
        <span className={style.descriptionChapter}>{ratingElement.tasc_name}</span>
      </div>
      <div className={style.textWrapper}>
        <p className={style.titleChapter}>Стадия задачи: </p>
        <span className={style.descriptionChapter}>{ratingElement.testingstage_name}</span>
      </div>
      <div className={style.textWrapper}>
        <p className={style.titleChapter}>Тренажер: </p>
        <span className={style.descriptionChapter}>{ratingElement.trainer_name}</span>
      </div>
      <div className={style.textWrapper}>
        <p className={style.titleChapter}>Академический уровень: </p>
        <span className={style.descriptionChapter}>{ratingElement.universitylevel_name}</span>
      </div>
      <div className={style.textWrapper}>
        <p className={style.titleChapter}>Количество: </p>
        <span className={style.descriptionChapter}>{ratingElement.count}</span>
      </div>
    </div>
  )
}